import { PaginatedResponse } from "@utils/types/main";
import axiosInstance from "./index.services";
import { CricketTeamType } from "@pages/dashboard/marketingEvents/cricket/teams/column/index.column";

export async function CricketMatchFetch(){
  const res = await axiosInstance.get<PaginatedResponse<CricketTeamType>>(`/cricket-team/`);
  return res?.data;
}

export async function CricketMatchPost(data:any){
  return await axiosInstance.post(`/cricket-match/ `, data)
}

export async function CricketMatchUpdate(id:any,data:any){
  return await axiosInstance.patch(`/cricket-match/${id}/ `, data)
}